export const AUTHENTICATION = 'authentication';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_NAVIGATION_DATA = 'SET_NAVIGATION_DATA';
export const CLEAR_LOCAL_DATA = 'CLEAR_LOCAL_DATA';
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const DELETE_FORM_DATA = 'DELETE_FORM_DATA';
export const CLEAR_PREVIOUS_DATA = 'isClearPrevData';
export const REMOVE_ITEM_FROM_FORM_DATA = 'REMOVE_ITEM_FROM_FORM_DATA';
export const FORM_DATA_CONTEXT_DATA = 'fdc';
export const LOAD_LOCAL_DATA = 'LOAD_LOCAL_DATA';
export const PREPARE_DIRS = 'PREPARE_DIRS';
export const CLEAR_NAVIGATION_DATA = 'CLEAR_NAVIGATION_DATA';
export const SET_CLINIC_INFO = 'SET_CLINIC_INFO';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
export const SET_NAVIGATION_DATA_FUNCTIONS = 'SET_NAVIGATION_DATA_FUNCTIONS';
export const SET_NAVIGATION_DATA_SLOTS_COUNT =
  'SET_NAVIGATION_DATA_SLOTS_COUNT';
export const SET_NAVIGATION_DATA_SLOTS_COUNT_ROLE =
  'SET_NAVIGATION_DATA_SLOTS_COUNT_ROLE';
export const NAVIGATION_DATA = 'nd';
